import axios from 'axios';
import { EventBus } from '../utilities/event.bus';
import { GameSvc } from '../services/game.service';

class Configuration {
  /** @constructor */
  constructor() {}

  get(cb) {
    if (sevenConfig.data.product.configRoute) {
      this['get' + sevenConfig.data.dp + 'Config']().then(cb);
    } else {
      this._setConfigData(null, cb);
    }
  }

  /**
   * Get retail config
   * @returns {Promise}
   */
  getRetailConfig() {
    let config = {
      headers: {
        'X-NSFT-SEVEN-COMPANY-UUID': sevenConfig.data.company.uuid,
        'HTTP-X-NAB-COMPANY-ID': sevenConfig.data.company.id,
        'HTTP-X-NAB-DEVICE-UUID': sevenConfig.data.betshop.device.uuid,
        'X-SEVEN-DEVICE-TOKEN': sevenConfig.data.betshop.device.token,
        'HTTP-X-NAB-BETSHOP-ID': sevenConfig.data.betshop.id,
        'HTTP-X-NAB-DP': 'Retail',
        'SEVEN-LOCALE': sevenConfig.data.company.language,
        'Authorization': 'Bearer ' + sevenConfig.data.user.auth.token,
      },
    };

    return axios.get(sevenConfig.data.product.configRoute, config)
      .then(response => {
        this._setConfigData(response);
      }).catch(error => {
        console.warn('Failure on config fetch', error);
      });
  }

  /**
   * Get terminal config
   * @returns {Promise}
   */
  getTerminalConfig() {
    let deviceUuid;
    if (sevenConfig.data.betshop.device) {
      deviceUuid = sevenConfig.data.betshop.device.uuid;
    }

    let config = {
      headers: {
        'X-NSFT-SEVEN-COMPANY-UUID': sevenConfig.data.company.uuid,
        'HTTP-X-NAB-COMPANY-ID': sevenConfig.data.company.id,
        'HTTP-X-NAB-DEVICE-UUID': deviceUuid,
        'HTTP-X-NAB-BETSHOP-ID': sevenConfig.data.betshop.id,
        'HTTP-X-NAB-DP': 'Terminal',
        'SEVEN-LOCALE': sevenConfig.data.company.language,
        'Authorization': 'Basic ' + btoa(sevenConfig.data.account.uuid + ':' + sevenConfig.data.account.password),
      },
    };

    return axios.get(sevenConfig.data.product.configRoute, config)
      .then(response => {
        this._setConfigData(response);
      }).catch(error => {
        console.warn('Failure on config fetch', error);
      });
  }

  /**
   * Get web config
   * @returns {Promise}
   */
  getWebConfig() {
    let config = {
      headers: {
        'HTTP-X-NAB-DP': 'Web',
        'SEVEN-LOCALE': sevenConfig.data.company.language,
        'HTTP-X-SEVEN-CLUB-UUID': sevenConfig.data.company.uuid,
      },
    };

    return axios.get(sevenConfig.data.product.configRoute, config)
      .then(response => {
        this._setConfigData(response);
      }).catch(error => {
        console.warn('Failure on config fetch', error);
      });
  }

  /**
   * Emit info about fetched config and set config data to game service
   * @param data {object}
   * @private
   */
  _setConfigData(data, cb) {
    if (data) {
      sevenConfig.data.config = data.data.config;
    }

    EventBus.$emit('Config.Fetched');

    let gameSvc = GameSvc.getGameSvc();
    gameSvc.taxes = sevenConfig.data.config.taxes;
    gameSvc.rules = sevenConfig.data.config.rules;

    if (cb) {
      cb();
    }
  }
}

export default Configuration;



// WEBPACK FOOTER //
// configuration.js